import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import Vant from "vant";
import "vant/lib/index.css";
// import "lib-flexible/flexible.js";
import "video.js/dist/video-js.css"; // 引入video.js的css
import hls from "videojs-contrib-hls"; // 播放hls流需要的插件

// 引入全局样式文件
import "@/assets/scss/index.scss";

createApp(App)
  .use(store)
  .use(router)
  .use(Vant)
  .use(hls)
  .mount("#app");
